import React, { useRef } from 'react';
import { useReactiveVar } from '@apollo/client';

import { IFormImperativeHandleProps } from '../../../common';
import { EcpFiltersModal as EcpFiltersModalView } from './ecp-filters-modal';
import { EcpFiltersModalProps } from './ecp-filters-modal.models';
import { filterParams } from '../../../../graphql/ecp-locator/ecp-locator.cache';
import { useActionsInProgress } from '../../../../graphql';
import { isFilterStateDefault } from './utils/is-filter-state-default';
import { DEFAULT_FILTERS } from '../../../../constants/ecp-locator';
import { TFiltersData } from '../../../../models';

export const EcpFiltersModal = ({ ecpService, updateStores, ...props }: EcpFiltersModalProps): JSX.Element => {
  const { onClose } = props;
  const ecpFiltersFormRef = useRef<IFormImperativeHandleProps>(null);
  const currentFilters = useReactiveVar(filterParams);
  const { addActionInProgress, removeActionInProgress } = useActionsInProgress();
  const isResetButtonDisabled = isFilterStateDefault(currentFilters);

  const requestToUpdateStores = async (filters: TFiltersData) => {
    try {
      addActionInProgress();
      await updateStores({ filters });
    } finally {
      removeActionInProgress();
      onClose!();
    }
  };

  const handleApplyFilters = async (values: TFiltersData) => {
    await requestToUpdateStores({
      ...values,
    });
  };

  const handleApplyFiltersButtonClick = () => {
    if (ecpFiltersFormRef.current) {
      ecpFiltersFormRef.current.submit();
    }
  };

  const handleResetFilters = async () => {
    await requestToUpdateStores({
      ...DEFAULT_FILTERS,
    });
  };

  return (
    <EcpFiltersModalView
      {...props}
      ref={ecpFiltersFormRef}
      defaultValues={currentFilters}
      isResetButtonDisabled={isResetButtonDisabled}
      onApplyFilters={handleApplyFilters}
      onSubmitButtonClick={handleApplyFiltersButtonClick}
      onResetFilters={handleResetFilters}
      ecpService={ecpService}
    />
  );
};
